// Import data from individual site files
import { configData as configDataGoParts, contentData as contentDataGoParts } from './GoParts/websitesDataGoParts.js';
import { configData as configDataBarigui, contentData as contentDataBarigui } from './Barigui/websitesDataBarigui.js';
import { configData as configDataAkta, contentData as contentDataAkta } from './Akta/websitesDataAkta.js';
import { configData as configDataApia, contentData as contentDataApia } from './Apia/websitesDataApia.js';
import { configData as configDataAsuka, contentData as contentDataAsuka } from './Asuka/websitesDataAsuka.js';
import { configData as configDataBarao, contentData as contentDataBarao } from './Barao/websitesDataBarao.js';
import { configData as configDataBelcarFiat, contentData as contentDataBelcarFiat } from './BelcarFiat/websitesDataBelcarFiat.js';
import { configData as configDataBelcarVW, contentData as contentDataBelcarVW } from './BelcarVW/websitesDataBelcarVW.js';
import { configData as configDataBelcarYamaha, contentData as contentDataBelcarYamaha } from './BelcarYamaha/websitesDataBelcarYamaha.js';
import { configData as configDataCaraiga, contentData as contentDataCaraiga } from './Caraiga/websitesDataCaraiga.js';
import { configData as configDataCarlider, contentData as contentDataCarlider } from './Carlider/websitesDataCarlider.js';
import { configData as configDataCarrera, contentData as contentDataCarrera } from './Carrera/websitesDataCarrera.js';
import { configData as configDataDiscautol, contentData as contentDataDiscautol } from './Discautol/websitesDataDiscautol.js';
import { configData as configDataEstilo, contentData as contentDataEstilo } from './Estilo/websitesDataEstilo.js';
import { configData as configDataEurokraft, contentData as contentDataEurokraft } from './Eurokraft/websitesDataEurokraft.js';
import { configData as configDataEuroville, contentData as contentDataEuroville } from './Euroville/websitesDataEuroville.js';
import { configData as configDataFiatValore, contentData as contentDataFiatValore } from './FiatValore/websitesDataFiatValore.js';
import { configData as configDataG4R, contentData as contentDataG4R } from './G4R/websitesDataG4R.js';
import { configData as configDataGermanica, contentData as contentDataGermanica } from './Germanica/websitesDataGermanica.js';
import { configData as configDataGlobo, contentData as contentDataGlobo } from './Globo/websitesDataGlobo.js';
import { configData as configDataIesa, contentData as contentDataIesa } from './Iesa/websitesDataIesa.js';
import { configData as configDataItavema, contentData as contentDataItavema } from './Itavema/websitesDataItavema.js';
import { configData as configDataItavemaByd, contentData as contentDataItavemaByd } from './ItavemaByd/websitesDataItavemaByd.js';
import { configData as configDataItavemaFiat, contentData as contentDataItavemaFiat } from './ItavemaFiat/websitesDataItavemaFiat.js';
import { configData as configDataItavemaHyundai, contentData as contentDataItavemaHyundai } from './ItavemaHyundai/websitesDataItavemaHyundai.js';
import { configData as configDataItavemaRenault, contentData as contentDataItavemaRenault } from './ItavemaRenault/websitesDataItavemaRenault.js';
import { configData as configDataItavemaToyota, contentData as contentDataItavemaToyota } from './ItavemaToyota/websitesDataItavemaToyota.js';
import { configData as configDataItavemaVolvo, contentData as contentDataItavemaVolvo } from './ItavemaVolvo/websitesDataItavemaVolvo.js';
import { configData as configDataLuson, contentData as contentDataLuson } from './Luson/websitesDataLuson.js';
import { configData as configDataNissul, contentData as contentDataNissul } from './Nissul/websitesDataNissul.js';
import { configData as configDataNissulYamaha, contentData as contentDataNissulYamaha } from './NissulYamaha/websitesDataNissulYamaha.js';
import { configData as configDataOpen, contentData as contentDataOpen } from './Open/websitesDataOpen.js';
import { configData as configDataPampa, contentData as contentDataPampa } from './Pampa/websitesDataPampa.js';
import { configData as configDataProvence, contentData as contentDataProvence } from './Provence/websitesDataProvence.js';
import { configData as configDataRecol, contentData as contentDataRecol } from './Recol/websitesDataRecol.js';
import { configData as configDataRecreio, contentData as contentDataRecreio } from './Recreio/websitesDataRecreio.js';
import { configData as configDataRevemar, contentData as contentDataRevemar } from './Revemar/websitesDataRevemar.js';
import { configData as configDataSavol, contentData as contentDataSavol } from './Savol/websitesDataSavol.js';
import { configData as configDataTopcar, contentData as contentDataTopcar } from './Topcar/websitesDataTopcar.js';
import { configData as configDataUmuarama, contentData as contentDataUmuarama } from './Umuarama/websitesDataUmuarama.js';
import { configData as configDataUmuaramaHD, contentData as contentDataUmuaramaHD } from './UmuaramaHD/websitesDataUmuaramaHD.js';
import { configData as configDataUmuaramaMotos, contentData as contentDataUmuaramaMotos } from './UmuaramaMotos/websitesDataUmuaramaMotos.js';
import { configData as configDataVecol, contentData as contentDataVecol } from './Vecol/websitesDataVecol.js';
import { configData as configDataVigorito, contentData as contentDataVigorito } from './Vigorito/websitesDataVigorito.js';
import { configData as configDataMaggi, contentData as contentDataMaggi } from './Maggi/websitesDataMaggi.js';
import { configData as configDataCarburgo, contentData as contentDataCarburgo } from './Carburgo/websitesDataCarburgo.js';

// Organize all site data in a single object
export const websitesData = {
    'GoParts': {
        configData: configDataGoParts,
        contentData: contentDataGoParts
    },
    'Barigui': {
        configData: configDataBarigui,
        contentData: contentDataBarigui
    },
    'Akta': {
        configData: configDataAkta,
        contentData: contentDataAkta
    },
    'Apia': {
        configData: configDataApia,
        contentData: contentDataApia
    },
    'Asuka': {
        configData: configDataAsuka,
        contentData: contentDataAsuka
    },
    'Barao': {
        configData: configDataBarao,
        contentData: contentDataBarao
    },
    'BelcarFiat': {
        configData: configDataBelcarFiat,
        contentData: contentDataBelcarFiat
    },
    'BelcarVW': {
        configData: configDataBelcarVW,
        contentData: contentDataBelcarVW
    },
    'BelcarYamaha': {
        configData: configDataBelcarYamaha,
        contentData: contentDataBelcarYamaha
    },
    'Caraiga': {
        configData: configDataCaraiga,
        contentData: contentDataCaraiga
    },
    'Carlider': {
        configData: configDataCarlider,
        contentData: contentDataCarlider
    },
    'Carrera': {
        configData: configDataCarrera,
        contentData: contentDataCarrera
    },
    'Discautol': {
        configData: configDataDiscautol,
        contentData: contentDataDiscautol
    },
    'Estilo': {
        configData: configDataEstilo,
        contentData: contentDataEstilo
    },
    'Eurokraft': {
        configData: configDataEurokraft,
        contentData: contentDataEurokraft
    },
    'Euroville': {
        configData: configDataEuroville,
        contentData: contentDataEuroville
    },
    'FiatValore': {
        configData: configDataFiatValore,
        contentData: contentDataFiatValore
    },
    'G4R': {
        configData: configDataG4R,
        contentData: contentDataG4R
    },
    'Germanica': {
        configData: configDataGermanica,
        contentData: contentDataGermanica
    },
    'Globo': {
        configData: configDataGlobo,
        contentData: contentDataGlobo
    },
    'Iesa': {
        configData: configDataIesa,
        contentData: contentDataIesa
    },
    'Itavema': {
        configData: configDataItavema,
        contentData: contentDataItavema
    },
    'ItavemaByd': {
        configData: configDataItavemaByd,
        contentData: contentDataItavemaByd
    },
    'ItavemaFiat': {
        configData: configDataItavemaFiat,
        contentData: contentDataItavemaFiat
    },
    'ItavemaHyundai': {
        configData: configDataItavemaHyundai,
        contentData: contentDataItavemaHyundai
    },
    'ItavemaRenault': {
        configData: configDataItavemaRenault,
        contentData: contentDataItavemaRenault
    },
    'ItavemaToyota': {
        configData: configDataItavemaToyota,
        contentData: contentDataItavemaToyota
    },
    'ItavemaVolvo': {
        configData: configDataItavemaVolvo,
        contentData: contentDataItavemaVolvo
    },
    'Luson': {
        configData: configDataLuson,
        contentData: contentDataLuson
    },
    'Nissul': {
        configData: configDataNissul,
        contentData: contentDataNissul
    },
    'NissulYamaha': {
        configData: configDataNissulYamaha,
        contentData: contentDataNissulYamaha
    },
    'Open': {
        configData: configDataOpen,
        contentData: contentDataOpen
    },
    'Pampa': {
        configData: configDataPampa,
        contentData: contentDataPampa
    },
    'Provence': {
        configData: configDataProvence,
        contentData: contentDataProvence
    },
    'Recol': {
        configData: configDataRecol,
        contentData: contentDataRecol
    },
    'Recreio': {
        configData: configDataRecreio,
        contentData: contentDataRecreio
    },
    'Revemar': {
        configData: configDataRevemar,
        contentData: contentDataRevemar
    },
    'Savol': {
        configData: configDataSavol,
        contentData: contentDataSavol
    },
    'Topcar': {
        configData: configDataTopcar,
        contentData: contentDataTopcar
    },
    'Umuarama': {
        configData: configDataUmuarama,
        contentData: contentDataUmuarama
    },
    'UmuaramaHD': {
        configData: configDataUmuaramaHD,
        contentData: contentDataUmuaramaHD
    },
    'UmuaramaMotos': {
        configData: configDataUmuaramaMotos,
        contentData: contentDataUmuaramaMotos
    },
    'Vecol': {
        configData: configDataVecol,
        contentData: contentDataVecol
    },
    'Vigorito': {
        configData: configDataVigorito,
        contentData: contentDataVigorito
    },
    'Maggi': {
        configData: configDataMaggi,
        contentData: contentDataMaggi
    },
    'Carburgo': {
        configData: configDataCarburgo,
        contentData: contentDataCarburgo
    },
};

// Helper function to get data for a specific site
export const getSiteData = (currentSite) => {
    if (!websitesData[currentSite]) {
        console.warn(`Site data not found for: ${currentSite}. Falling back to GoParts.`);
        return websitesData['GoParts'];
    }
    return websitesData[currentSite];
};

// Helper function to get config data for a specific site
export const getConfigData = (currentSite) => {
    return getSiteData(currentSite).configData;
};

// Helper function to get content data for a specific site
export const getContentData = (currentSite) => {
    return getSiteData(currentSite).contentData;
};

// For backward compatibility, export default data (GoParts)
export const configData = configDataGoParts;
export const contentData = contentDataGoParts;
